import { Flex } from "@/atoms"
import { HeaderPage } from "@/organisms/HeaderPage"
import { ListIntegrations } from "@/pages/IntegrationsPage/components/organisms/ListIntegrations"
import { ListIntegrationsMenu } from "@/pages/IntegrationsPage/components/organisms/ListIntegrationsMenu"
import { PageTemplate } from "@/templates/PageTemplate"

import styles from "./ListIntegrationsPage.module.scss"

export const ListIntegrationsPage = () => {
  return (
    <PageTemplate
      header={<HeaderPage titleTranslationKey="Integrations" />}
      classes={{ main: styles.main }}
    >
      <Flex gap={24}>
        <Flex vertical gap={16} className={styles.menu}>
          <ListIntegrationsMenu />
        </Flex>
        <ListIntegrations />
      </Flex>
    </PageTemplate>
  )
}
